import { InlineIcon } from "@iconify/react-with-api";
import clsx from "clsx";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IApplicationState } from "../../state/ducks";
import { MenuReducerState, menuAction } from "../../state/ducks/menu";

export interface SubMenuProps {
  title: string | React.ReactNode;
  datakey: string;
  children?: React.ReactNode;
}

const Component: React.FC<SubMenuProps> = (props) => {
  const { title, children, datakey, ...other } = props;

  const state = useSelector<IApplicationState, MenuReducerState>(
    (state) => state.menu
  );
  const dispatch = useDispatch();

  const ref = React.useRef<HTMLLIElement>(null);
  const ul = React.useRef<HTMLUListElement>(null);

  React.useEffect(() => {
    if (!ref.current) return;
    if (
      (children as React.ReactElement[]).find(
        (row) => row.props["datakey"] === state.selectedDatakey
      )
    ) {
      ref.current.classList.add("selected");
    } else {
      ref.current.classList.remove("selected");
    }
  }, [state.selectedDatakey, children]);

  const isOpening = state.openingDatakeys.findIndex((e) => e === datakey);
  const handleOpenClose = () => {
    if (isOpening > -1) {
      // Close
      const ary = [...state.openingDatakeys];
      ary.splice(isOpening, 1);
      if (ul.current) {
        ul.current.style.maxHeight = `0px`;
      }
      dispatch(menuAction({ ...state, openingDatakeys: ary }));
    } else {
      // Open
      if (ul.current) {
        ul.current.style.maxHeight = `${ul.current.scrollHeight}px`;
      }
      dispatch(
        menuAction({
          ...state,
          openingDatakeys: [...state.openingDatakeys, datakey],
        })
      );
    }
  };

  return (
    <li
      className={clsx(`submenu`, isOpening > -1 ? "open" : "close")}
      {...other}
      ref={ref}
    >
      <div className={clsx("title")} onClick={handleOpenClose}>
        {title}

        <InlineIcon icon={"mdi:chevron-down"} className="trigger" />
      </div>
      <ul ref={ul}>{children}</ul>
    </li>
  );
};

export const SubMenu = React.memo(Component);
